var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 94,
    viewBox: "0 0 97 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 93.7853,
    rx: 10,
    fill: "#448CB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6057 47.3343C28.667 46.5337 25.899 46.5503 23.055 47.327C21.6263 47.7165 20.667 48.9012 20.667 50.2745V51.0377C20.667 51.3769 20.965 51.6522 21.3337 51.6522H33.3337C33.7023 51.6522 34.0003 51.3769 34.0003 51.0377V50.2831C34.0003 48.9098 33.0383 47.7245 31.6057 47.3343Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.751 45.1014C29.8629 45.1014 31.501 42.7311 31.501 40.6922C31.501 38.608 29.8191 36.913 27.751 36.913C25.6829 36.913 24.001 38.608 24.001 40.6922C24.001 42.7311 25.6391 45.1014 27.751 45.1014Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1786 54.9276C38.6183 55.5824 38.0006 56.1893 37.334 56.7397L42.1561 61.4783L44.0007 59.6655L39.1786 54.9276Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.75 32C35.3315 32 41.5 38.0606 41.5 45.5109C41.5 52.9612 35.3315 59.0217 27.75 59.0217C20.1685 59.0217 14 52.9612 14 45.5109C14 38.0606 20.1685 32 27.75 32ZM15.3092 45.5108C15.3092 52.2515 20.8897 57.7349 27.7496 57.7349C34.6096 57.7349 40.1901 52.2515 40.1901 45.5108C40.1901 38.7702 34.6096 33.2867 27.7496 33.2867C20.8897 33.2867 15.3092 38.7702 15.3092 45.5108Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32L53 35.625V53.75L68 61L83 53.75V35.625L68 32ZM80 36.7125L68.9375 40.7L56.5625 36.7125L68 33.8125L80 36.7125V36.7125ZM54.875 52.6625V37.9812L68 42.3312V59.0062L54.875 52.6625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscSvg3);
export default __webpack_public_path__ + "static/media/DiscSVG3.00a407457103e6f596d5cf73070a033c.svg";
export { ForwardRef as ReactComponent };